/* Swoo theme scripts for BrujoStore */
(function () {
  'use strict';

  var SW = window.SW || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || SW.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }
  SW.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('.sw-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sw-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.classList.toggle('is-error', !!isError);
    el.innerHTML = '<span>' + msg + '</span>' + (isError ? '' : '<a href="' + root + 'cart">Ver carro</a>');
    requestAnimationFrame(function () { el.classList.add('is-show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 4000);
  }

  /* ---------- Cart ---------- */
  function syncCartTotal() {
    var src = $('#cart-icon-bubble [data-sw-cart-total-src]');
    if (!src) return;
    $$('[data-sw-cart-total]').forEach(function (el) { el.textContent = src.textContent; });
  }
  function renderBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = html.querySelector('.shopify-section');
    var bubble = $('#cart-icon-bubble');
    if (inner && bubble) bubble.innerHTML = inner.innerHTML;
    syncCartTotal();
  }
  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || data.message || 'Error');
        renderBubble(data.sections);
        refreshFreeShip().then(function (note) { toast('¡Producto agregado al carro!' + (note ? '<small>' + note + '</small>' : '')); });
        document.dispatchEvent(new CustomEvent('sw:cart-updated'));
        return data;
      })
      .catch(function (err) { toast(err.message || 'No se pudo agregar', true); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  SW.addToCart = addToCart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart([{ id: Number(btn.getAttribute('data-sw-add')), quantity: 1 }], btn);
  });

  var bubbleEl = $('#cart-icon-bubble');
  if (bubbleEl && 'MutationObserver' in window) {
    new MutationObserver(syncCartTotal).observe(bubbleEl, { childList: true, subtree: true });
  }

  /* ---------- Drawer ---------- */
  var drawer = $('[data-sw-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sw-drawer-open]')) setDrawer(true);
    else if (e.target.closest('[data-sw-drawer-close]')) setDrawer(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------- Search: drop empty category filter ---------- */
  $$('[data-sw-search]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var sel = $('[data-sw-search-cat]', form);
      if (sel && !sel.value) sel.disabled = true;
    });
  });

  /* ---------- Horizontal scrollers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-scroll]');
    if (!btn) return;
    var scope = btn.closest('.sw-carousel') || btn.closest('.sw-card');
    var sc = scope && $('[data-sw-scroller]', scope);
    if (!sc) return;
    var dir = Number(btn.getAttribute('data-sw-scroll'));
    sc.scrollBy({ left: dir * sc.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Hero slider ---------- */
  function initSlider(slider) {
    var slides = $$('.sw-slide', slider);
    if (slides.length < 2) return;
    var i = 0, timer;
    var current = $('[data-sw-current]', slider);
    var speed = Number(slider.getAttribute('data-autoplay')) || 0;
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (current) current.textContent = i + 1;
    }
    function play() { if (speed > 0) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed * 1000); } }
    var prev = $('[data-sw-prev]', slider), next = $('[data-sw-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', play);
    var x0 = null;
    slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); }
      x0 = null;
    });
    // Theme editor: show selected block
    document.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target);
      if (idx > -1) { clearInterval(timer); go(idx); }
    });
    play();
  }

  /* ---------- Tabs ---------- */
  function initTabs(wrap) {
    var btns = $$('[data-sw-tab]', wrap);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-sw-tab');
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        $$('[data-sw-panel]', wrap).forEach(function (p) {
          if (p.closest('[data-sw-tabs]') !== wrap) return;
          p.classList.toggle('is-active', p.getAttribute('data-sw-panel') === id);
        });
        refreshMore(wrap);
      });
    });
  }

  /* ---------- Gallery thumbs ---------- */
  function setMainImage(scope, src) {
    var main = $('.sw-gallery-main', scope);
    if (!main || !src) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = src;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sw-thumb]');
    if (!t) return;
    var scope = t.closest('[data-sw-gallery]');
    if (!scope) return;
    $$('[data-sw-thumb]', scope).forEach(function (x) { x.classList.toggle('is-active', x === t); });
    setMainImage(scope, t.getAttribute('data-sw-thumb'));
  });

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    var raw = (el.getAttribute('data-sw-countdown') || '').trim();
    var end;
    function nextMidnight() { var d = new Date(); d.setHours(24, 0, 0, 0); return d; }
    if (raw) {
      end = new Date(raw.replace(' ', 'T'));
      if (isNaN(end.getTime())) end = nextMidnight();
    } else end = nextMidnight();
    var D = $('[data-d]', el), H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - new Date());
      if (diff === 0 && !raw) { end = nextMidnight(); diff = end - new Date(); }
      var s = Math.floor(diff / 1000);
      D.textContent = Math.floor(s / 86400);
      H.textContent = pad(Math.floor(s % 86400 / 3600));
      M.textContent = pad(Math.floor(s % 3600 / 60));
      S.textContent = pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- "Ver más" toggles ---------- */
  function refreshMore(scope) {
    $$('[data-sw-more]', scope || document).forEach(function (wrap) {
      var body = $('.sw-seo__body, .sw-desc__body', wrap);
      var btn = $('[data-sw-more-toggle]', wrap);
      if (!body || !btn) return;
      if (wrap.classList.contains('is-open')) return;
      var overflow = body.scrollHeight > body.clientHeight + 4;
      btn.hidden = !overflow;
      if (!overflow) wrap.classList.add('is-open');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-more-toggle]');
    if (!btn) return;
    var wrap = btn.closest('[data-sw-more]');
    var open = wrap.classList.toggle('is-open');
    btn.textContent = open ? 'Ver menos' : 'Ver más';
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.sw-pdp__more')) return;
    var w = $('#descripcion [data-sw-more]');
    if (w) { w.classList.add('is-open'); var t = $('[data-sw-more-toggle]', w); if (t) t.textContent = 'Ver menos'; }
  });

  /* ---------- Product page ---------- */
  function initPDP(pdp) {
    var jsonEl = $('[data-sw-product-json]', pdp);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-sw-product-form]', pdp);
    var idInput = $('[data-sw-variant-id]', pdp);
    var qtyInput = $('[data-sw-qty-input]', pdp);
    var priceEl = $('[data-sw-price]', pdp);
    var compareEl = $('[data-sw-compare]', pdp);
    var totalEl = $('[data-sw-total]', pdp);
    var stockEl = $('[data-sw-stock]', pdp);
    var skuEl = $('[data-sw-sku]', pdp);
    var addBtn = $('[data-sw-add-btn]', pdp);
    var addLabel = $('[data-sw-add-label]', pdp);
    var buyBtn = $('[data-sw-buy-now]', pdp);
    var gallery = $('[data-sw-gallery]', pdp);

    var variant = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }
    var tiers = $$('[data-sw-tiers] input', pdp);
    function tierTotal(t) { var set = Number(t.getAttribute('data-price-set')) || 0; return set > 0 ? set : variant.price * Number(t.value); }
    function syncTiers() {
      var q = qty();
      tiers.forEach(function (t) {
        var set = Number(t.getAttribute('data-price-set')) || 0;
        var base = variant.price * Number(t.value);
        var box = t.closest('.sw-tier');
        var showSave = set > 0 && set < base;
        t.checked = Number(t.value) === q;
        var tot = $('[data-sw-tier-total]', box); if (tot) tot.textContent = formatMoney(tierTotal(t));
        var was = $('[data-sw-tier-was]', box); if (was) { was.textContent = formatMoney(base); was.hidden = !showSave; }
        var sv = $('[data-sw-tier-save]', box); if (sv) { sv.textContent = 'Ahorras ' + formatMoney(base - set); sv.hidden = !showSave; }
      });
    }
    function updateTotal() {
      syncTiers();
      var sel = tiers.filter(function (t) { return t.checked; })[0];
      if (totalEl) totalEl.textContent = formatMoney(sel ? tierTotal(sel) : variant.price * qty());
    }
    tiers.forEach(function (t) { t.addEventListener('change', function () { qtyInput.value = t.value; updateTotal(); }); });

    function selectedOptions() {
      return $$('[data-sw-option]', pdp).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function markAvailability() {
      var sel = selectedOptions();
      $$('[data-sw-option]', pdp).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = sel.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return test[j] == null || o === test[j]; });
          });
          input.closest('.sw-opt__btn').classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function onChange() {
      var sel = selectedOptions();
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, j) { return o === sel[j]; });
      });
      $$('[data-sw-option]', pdp).forEach(function (fs, idx) {
        var lbl = $('[data-sw-option-label]', fs);
        if (lbl) lbl.textContent = sel[idx] || '';
      });
      markAvailability();
      if (!match) {
        addBtn.disabled = true; if (buyBtn) buyBtn.disabled = true;
        addLabel.textContent = 'NO DISPONIBLE';
        return;
      }
      variant = match;
      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.classList.toggle('is-sale', !!sale);
      if (compareEl) { compareEl.hidden = !sale; if (sale) compareEl.textContent = formatMoney(variant.compare_at_price); }
      if (skuEl) skuEl.textContent = variant.sku || '—';
      if (stockEl) {
        stockEl.classList.toggle('sw-stock--in', variant.available);
        stockEl.classList.toggle('sw-stock--out', !variant.available);
        stockEl.innerHTML = variant.available ? '<svg class="sw-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5 10 17l9-10"/></svg> En stock' : 'Agotado';
      }
      addBtn.disabled = !variant.available; if (buyBtn) buyBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'AGREGAR AL CARRO' : 'AGOTADO';
      if (variant.featured_image && gallery) {
        setMainImage(gallery, variant.featured_image.src);
        $$('[data-sw-thumb]', gallery).forEach(function (t) {
          t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(variant.featured_media && variant.featured_media.id));
        });
      }
      updateTotal();
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-sw-option] input', pdp).forEach(function (i) { i.addEventListener('change', onChange); });
    if ($$('[data-sw-option]', pdp).length) markAvailability();

    $$('[data-sw-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + Number(b.getAttribute('data-sw-qty')));
        updateTotal();
      });
    });
    qtyInput.addEventListener('input', updateTotal);
    var preTier = tiers.filter(function (t) { return t.checked; })[0];
    if (preTier) qtyInput.value = preTier.value;
    if (tiers.length) updateTotal();

    if (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.hasAttribute('data-sw-buy-now')) return; // normal post -> checkout
        e.preventDefault();
        addToCart([{ id: Number(idInput.value), quantity: qty() }], addBtn);
      });
    }

    // Recently viewed
    try {
      var key = 'sw-recent';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage unavailable */ }
  }

  /* ---------- Bundle ---------- */
  function initBundle(b) {
    var total = $('[data-sw-bundle-total]', b);
    var items = $$('[data-sw-bundle-item]', b);
    function update() {
      var sum = 0;
      items.forEach(function (i) {
        if (i.checked) sum += Number(i.getAttribute('data-price'));
        var img = $('[data-sw-bundle-img="' + i.getAttribute('data-sw-bundle-item') + '"]', b);
        if (img) img.classList.toggle('is-off', !i.checked);
      });
      total.textContent = formatMoney(sum);
    }
    items.forEach(function (i) { i.addEventListener('change', update); });
    update();
    var btn = $('[data-sw-bundle-add]', b);
    btn.addEventListener('click', function () {
      var list = items.filter(function (i) { return i.checked; }).map(function (i) {
        return { id: Number(i.getAttribute('data-sw-bundle-item')), quantity: 1 };
      });
      if (list.length) addToCart(list, btn);
    });
  }

  /* ---------- Recently viewed ---------- */
  function initRecent(sec) {
    var list;
    try { list = JSON.parse(localStorage.getItem('sw-recent') || '[]'); } catch (e) { list = []; }
    var current = sec.getAttribute('data-current');
    var limit = Number(sec.getAttribute('data-limit')) || 4;
    list = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (!list.length) return;
    var target = $('[data-sw-recent-list]', sec);
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        return '<div class="sw-pcard sw-pcard--mini"><div class="sw-pcard__media"><a class="sw-pcard__img" href="' + p.url + '">' +
          (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '') +
          '</a></div><div class="sw-pcard__body"><a class="sw-pcard__title" href="' + p.url + '">' + p.title.replace(/</g, '&lt;') + '</a>' +
          '<div class="sw-price"><span class="sw-price__now' + (sale ? ' is-sale' : '') + '">' + formatMoney(p.price) + '</span>' +
          (sale ? '<s class="sw-price__was">' + formatMoney(p.compare_at_price) + '</s>' : '') + '</div></div></div>';
      }).join('');
      if (html) { target.innerHTML = html; sec.hidden = false; }
    });
  }

  /* ---------- Reviews ---------- */
  function initReviews(sec) {
    var more = $('[data-sw-reviews-more]', sec);
    var list = $('[data-sw-reviews-list]', sec);
    if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.remove(); });
    var count = Number(sec.getAttribute('data-count')) || 0;
    var avg = Number(sec.getAttribute('data-avg')) || 0;
    $$('[data-sw-rating-slot]').forEach(function (slot) {
      if (!count) { slot.hidden = true; return; }
      slot.innerHTML = '<span class="sw-stars" style="--s:15px"><span class="sw-stars__bg">★★★★★</span><span class="sw-stars__fg" style="width:' + Math.min(100, avg * 20) + '%">★★★★★</span></span>' +
        '<span>' + avg.toFixed(1) + ' · ' + count + (count === 1 ? ' reseña' : ' reseñas') + '</span>';
      slot.hidden = false;
    });
    if (/contact_posted=true/.test(location.search) && $('.sw-reviews__form .sw-alert--ok', sec)) sec.scrollIntoView();
  }

  /* ---------- Free shipping ---------- */
  function updateFreeShip(cart) {
    var bars = $$('[data-sw-fsbar]');
    if (!bars.length || !cart) return '';
    var note = '';
    bars.forEach(function (bar) {
      var th = Number(bar.getAttribute('data-threshold')) || 0;
      if (!th) return;
      var left = th - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / th));
      var msg = $('[data-sw-fsbar-msg]', bar);
      var fill = $('[data-sw-fsbar-fill]', bar);
      bar.classList.toggle('is-done', left <= 0);
      if (msg) msg.innerHTML = left > 0 ? 'Te faltan <b>' + formatMoney(left) + '</b> para tener <b>envío gratis</b>' : '¡Felicidades! Tu pedido tiene <b>envío gratis</b>';
      if (fill) fill.style.width = pct + '%';
      note = left > 0 ? 'Te faltan ' + formatMoney(left) + ' para envío gratis' : '¡Tu pedido tiene envío gratis!';
    });
    return note;
  }
  function refreshFreeShip() {
    if (!$('[data-sw-fsbar]')) return Promise.resolve('');
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(updateFreeShip).catch(function () { return ''; });
  }
  document.addEventListener('sw:cart-updated', refreshFreeShip);
  if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshFreeShip(); });

  /* ---------- Announcement rotation ---------- */
  function initAnnounce(bar) {
    var msgs = $$('.sw-announce__msg', bar);
    if (msgs.length < 2) return;
    var i = 0, speed = (Number(bar.getAttribute('data-speed')) || 4) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || document;
    $$('[data-sw-slider]', scope).forEach(initSlider);
    $$('[data-sw-tabs]', scope).forEach(initTabs);
    $$('[data-sw-countdown]', scope).forEach(initCountdown);
    $$('[data-sw-pdp]', scope).forEach(initPDP);
    $$('[data-sw-bundle]', scope).forEach(initBundle);
    $$('[data-sw-recent]', scope).forEach(initRecent);
    $$('[data-sw-reviews]', scope).forEach(initReviews);
    $$('[data-sw-announce]', scope).forEach(initAnnounce);
    refreshMore(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () { refreshMore(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.SW = SW;
})();
/* BrujoStore: cupon BIENVENIDO5 pago anticipado (caja en producto + pop-up) */
(function(){var C='BIENVENIDO5';
function ap(){try{fetch('/discount/'+C).catch(function(){})}catch(e){}try{navigator.clipboard.writeText(C)}catch(e){}}
function box(){if(!/\/products\//.test(location.pathname))return;var f=document.querySelector('.sw-buybox__form');if(!f||f.querySelector('.bj-cupon'))return;var d=document.createElement('div');d.className='bj-cupon';d.innerHTML='<span>🎁 <b>5% OFF extra</b> pagando online con el código</span><button type="button" class="bj-cupon__code">'+C+' · Toca para aplicar</button>';var b=d.querySelector('button');b.addEventListener('click',function(){ap();b.textContent='✓ ¡Aplicado! Se descuenta al pagar'});var add=f.querySelector('[data-sw-add-btn]');f.insertBefore(d,add||f.firstChild)}
function pop(){if(!/\/products\//.test(location.pathname))return;try{if(sessionStorage.getItem('bjpop'))return;sessionStorage.setItem('bjpop','1')}catch(e){}var o=document.createElement('div');o.className='bj-pop';o.innerHTML='<div class="bj-pop__box"><button type="button" class="bj-pop__x" aria-label="Cerrar">×</button><p class="bj-pop__t">¡Espera! 🎁</p><p class="bj-pop__s">Llévate <b>5% OFF</b> en tu compra pagando online</p><div class="bj-pop__c">'+C+'</div><button type="button" class="bj-pop__btn">Aplicar mi descuento</button><p class="bj-pop__n">Válido pagando online (Webpay, tarjetas o Mercado Pago) · Envío gratis</p></div>';document.body.appendChild(o);function cl(){o.remove()}o.addEventListener('click',function(e){if(e.target===o||e.target.classList.contains('bj-pop__x'))cl()});o.querySelector('.bj-pop__btn').addEventListener('click',function(){ap();this.textContent='✓ ¡Listo! Se aplicará al pagar';setTimeout(cl,1800)})}
function go(){box()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go()})();
